<app-donation-table
  [dataSource]="stoppedDonations"
  [displayEntityHeaders]="false"
  [donationColumns]="['fullName', 'emailAddress', 'amount', 'group', 'frequency', 'stopOnDate']"
  [lastPaymentColumns]="[]"
  [enableSort]="true"
  (sortChange)="sortDonations($event)"
>
</app-donation-table>
